<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-padding-bottom-16">
    <span class="cf-icon cf-icon--red cf-icon--large far fa-exclamation-circle" />

    <h2 class="cf-title cf-title--2">
      {{ content.DeleteAccountPrompt.title }}
    </h2>

    <p class="cf-subtitle cf-subtitle--2">
      {{ content.DeleteAccountPrompt.description }}
    </p>

    <button
      type="button"
      :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--loading': loading }]"
      @click="deleteAccountHandler"
    >
      {{ content.DeleteAccountPrompt.metadata.deleteAccountPrimaryCta }}
    </button>

    <button
      type="button"
      class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
      @click="$closeModal('deleteMyAccount')"
    >
      {{ content.DeleteAccountPrompt.metadata.deleteAccountSecondaryCta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'DeleteAccount',

    data: () => ({
      loading: false
    }),

    computed: {
      ...mapGetters('content', ['content'])
    },

    methods: {
      async deleteAccountHandler() {
        this.loading = true;
        await this.$store.dispatch('session/requestAccountDeletion');
        this.$closeModal('deleteMyAccount');
        this.loading = false;
      }
    }
  };
</script>
